var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "import-reports-view"
  }, [_c('h1', [_vm._v("Warteschlange")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.queuedJobs.running) + " laufen, " + _vm._s(_vm.queuedJobs.pending) + " warten")]), _vm._v(" "), (_vm.gridLoaded) ? _c('data-grid', {
    staticClass: "uk-margin-medium",
    attrs: {
      "columns": _vm.gridColumns,
      "editable": false,
      "is-loading": _vm.isLoading,
      "page-info": {},
      "removable": false,
      "rows": _vm.queuedJobs.entries
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(statusProps) {
        return [(statusProps.value) ? _c('span', [_vm._v("\n         " + _vm._s(statusProps.value) + "\n       ")]) : _c('text-placeholder')]
      }
    }, {
      key: "createdAt",
      fn: function(createdAtProps) {
        return [(createdAtProps.value) ? _c('span', [_vm._v("\n         " + _vm._s(_vm._f("niceTime")(createdAtProps.value)) + "\n       ")]) : _c('text-placeholder')]
      }
    }, {
      key: "function",
      fn: function(functionProps) {
        return [(functionProps.value) ? _c('span', [_vm._v("\n         " + _vm._s(functionProps.value) + "\n       ")]) : _c('text-placeholder')]
      }
    }])
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a7fb1b8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/QueuedJobs.vue
// module id = 1974
// module chunks = 0